module.exports = __webpack_public_path__ + "img/icon-job.182c7023.svg";